import { getEarnCategoryTranslationKey } from '@/features/earn/utils/getEarnCategoryTranslationKey';
import { LayoutContext } from 'contexts/LayoutContext';
import { View, SxProp, useDripsyTheme } from 'dripsy';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Space } from '../../Space';
import { DonutChartLegendItem } from './DonutChartLegendItem';

export interface DonutChartLegendItem {
  name: string;
  percentage: string | number;
  data: Array<string>;
}
export interface DonutChartLegendProps {
  showValue?: boolean;
  legendData: Array<DonutChartLegendItem>;
  selectArc: (index: number) => void;
}

export const DonutChartLegend: React.FC<DonutChartLegendProps> = ({ showValue, legendData, selectArc }) => {
  const { theme } = useDripsyTheme();

  const colors = [theme.colors?.$pieChart0, theme.colors?.$pieChart1, theme.colors?.$pieChart2, theme.colors?.$pieChart3];

  const layout = useContext(LayoutContext);

  const styles = layout.isMobile ? stylesNative : stylesWeb;

  const { t } = useTranslation('earn');

  return (
    <View sx={styles.container}>
      {legendData.map((item, index) => {
        return (
          <React.Fragment key={`donut-chart-legend-${item.name}-${index}`}>
            {index > 0 && <Space height="$3" />}
            <DonutChartLegendItem
              key={`${item.name}-donut-chart-legend-item-${index}`}
              label={t(getEarnCategoryTranslationKey(item.name))}
              color={colors[index]}
              data={item.data}
              onPress={() => selectArc(index)}
              showValue={showValue}
            />
          </React.Fragment>
        );
      })}
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const stylesWeb: Record<StyleName, SxProp> = {
  container: {
    flex: 1
  }
};

const stylesNative: Record<StyleName, SxProp> = {
  container: {
    flex: 1
  }
};
